import * as React from 'react';
import styled from 'styled-components';
import { TextInput as CoreTextInput } from 'forms-core-components';
import { colors, fonts } from 'bench-style-constants';

const StyledTextInput = styled(CoreTextInput)`
  padding: 8px 16px;
  background: ${colors.shell};
  border: 0;
  border-radius: 0.25rem;
  color: ${colors.charcoal};
  font-family: ${fonts.circular};
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  transition: background 0.25s ease-in-out, color 0.25s ease-in-out;

  &:focus {
    outline: 0;
    box-shadow: inset 0 0 0 1px ${colors.stream};
  }

  &::placeholder {
    color: ${colors.dust};
  }

  ${({ size }) => size === 'large' && 'padding: 16px 24px;'};
`;

const TextInput = props => <StyledTextInput {...props} />;

TextInput.defaultProps = {
  size: 'medium',
  fullWidth: false,
};

export default TextInput;
